var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0002 21C11.7048 21 11.4142 20.9109 11.1564 20.7375C9.3939 19.5422 6.83453 17.6906 4.99703 15.45C3.12203 13.1672 2.22203 10.8188 2.25015 8.27813C2.27828 5.36719 4.61734 3 7.45796 3C9.71265 3 11.208 4.38281 12.0002 5.39062C12.7923 4.38281 14.2877 3 16.5423 3C19.383 3 21.7173 5.36719 21.7502 8.27813C21.7736 10.8188 20.8783 13.1672 19.0033 15.45C17.1658 17.6906 14.6064 19.5422 12.8439 20.7375C12.5861 20.9156 12.2955 21 12.0002 21ZM7.45796 4.5C5.43765 4.5 3.77359 6.20156 3.75015 8.29688C3.69859 13.2 7.8939 16.7156 12.0002 19.5C16.1064 16.7109 20.3017 13.2 20.2502 8.29688C20.2267 6.20625 18.5673 4.5 16.5423 4.5C14.0111 4.5 12.6798 7.05937 12.6705 7.0875C12.5439 7.34062 12.2861 7.5 12.0002 7.5C11.7142 7.5 11.4564 7.34063 11.3298 7.08281C11.3158 7.05938 9.98453 4.5 7.45796 4.5Z",
    fill: "#667E87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a3c4ac869cc6ba14a6f6dc475df5e8c9.svg";
export { ForwardRef as ReactComponent };